import React, { useState } from 'react';
import Logo from './Logo';
import { Navbar } from 'react-bootstrap'
import GoToTop from '../utilities/GoToTop';
import HideBeacon from '../utilities/HideBeacon';


function Subheader() {
    return (
        <div
            style={{
                width: '100%',
                color: '#fff',
                backgroundColor: '#1d1d1d',
                borderBottom: '1px solid rgb(204, 204, 204)',
            }} className="pt-1 "
        >
            <GoToTop />
            <HideBeacon />
            <div style={{ display: 'flex', backgroundColor: '#1d1d1d' }} className=""  >
                <div className="container-fluid position-relative mx-0 px-0 " style={{ backgroundColor: '#1d1d1d', marginTop: '10px' }}  >
                    <Navbar collapseOnSelect expand="lg" className="p-0 tab-nav">
                        <div className=" tab-menu d-lg-flex" >
                            <div className="navbar-dark d-lg-flex p-2 " style={{ backgroundColor: '#1d1d1d' }}>
                                <Navbar.Brand className="pr-lg-5"><Logo /></Navbar.Brand>
                            </div>
                        </div>
                    </Navbar>
                </div>
            </div>
        </div>
    );
}

export default React.memo(Subheader);
